import "../../styles/forms/enquiry.scss";

// Function to sanitize a JSON string
window.sanitiseJSON = function(jsonString) {
    return jsonString.replace(/[\n\r\t]/g, function(match) {
        if (match === '\n') return '\\n';
        if (match === '\r') return '\\r';
        if (match === '\t') return '\\t';
    });
}
